import React, { Component } from "react";
import { connect } from "react-redux";
import "../style.css";
import { CircularProgress } from "@material-ui/core";
import Provinces from "./Provinces";

class index extends Component {
  state = {};
  render() {
    const { language, countriesFullyLoaded, selectedCountryID, countries } =
      this.props;
    return (
      <div style={{ marginTop: 30 }}>
        <p
          className="box-title"
          style={{ textAlign: language === "arabic" ? "right" : "left" }}
        >
          {language == "arabic" ? "العنوان" : "Location"}
        </p>
        <div
          className="bordered"
          style={{
            height: "100%",
            minHeight: 500,
            backgroundColor: "white",
            display: !countriesFullyLoaded && "grid",
            direction: language === "arabic" ? "rtl" : "ltr",
          }}
        >
          {countriesFullyLoaded ? (
            <div>
              <Provinces
                selectedCountryID={selectedCountryID}
                setBranchDeliveryChargeID={this.props.setBranchDeliveryChargeID}
                branchDeliveryChargeID={this.props.branchDeliveryChargeID}
                setAddressesOpen={this.props.setAddressesOpen}
                OpenBranchSelectDrawer={this.props.OpenBranchSelectDrawer}
              />
            </div>
          ) : (
            <CircularProgress
              color="primary"
              style={{
                alignSelf: "center",
                justifySelf: "center",
                width: 30,
                height: 30,
              }}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    countries: state.store.store.all_countries || state.store.store.countries,
    language: state.store.language,
    countriesFullyLoaded: !state.store.thirdLoading,
  };
};
export default connect(mapStateToProps)(index);
